module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/azure-1a9aa14b2f29249e6b6540d04a8f10d4.svg";